import { useFormik } from "formik";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { userLogin } from "../../store/AsyncMethods/AuthMethod";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RESET_ERROR, RESET_SUCCESS } from "../../store/Types/AuthTypes";
import { toast } from "react-toastify";
import { PrimeIcons } from "primereact/api";
import { getSetupDetails } from "../../store/AsyncMethods/SetupMethod";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, success } = useSelector((state) => state.AuthReducer);
  const { setupDetails } = useSelector((state) => state.SetupReducer);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    dispatch(getSetupDetails());
  }, []);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: RESET_ERROR });
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      toast.success(success);
      setTimeout(() => {
        dispatch({ type: RESET_SUCCESS });
      }, 2000);
    }
  }, [success]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid Email").required("Email Required"),
      password: Yup.string().required("Password Required"),
    }),

    onSubmit: async (data) => {
      dispatch(userLogin(data, formik)).then((success) => {
        if (success) {
          navigate("/dashboard");
        }
      });
    },
  });

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: "#f5f7ff" }}>
      <div className="card" style={{ width: "100%", maxWidth: "420px", padding: "2rem", borderRadius: "12px", boxShadow: "0 4px 24px rgba(0,0,0,0.10)" }}>

        {setupDetails?.logo && (
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
            <img src={setupDetails.logoPath + setupDetails.logo} alt="Uploaded Logo" style={{ width: "120px" }} />
          </div>
        )}

        <h1 className="p-font-style" style={{ fontSize: "1.6rem", fontWeight: "700", textAlign: "center", marginBottom: "1.8rem" }}>
          Sign in to your account
        </h1>

        <form onSubmit={formik.handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.2rem" }}>

          {/* Email */}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label htmlFor="email" style={{ fontWeight: "500" }}>Email</label>
            <InputText
              id="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              className="p-primary-input"
              style={{ width: "100%", fontSize: "1rem", padding: "0.65rem 0.75rem" }}
            />
            {formik.touched?.email && formik.errors?.email && (
              <div className="p-error">{formik.errors?.email}</div>
            )}
          </div>

          {/* Password */}
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label htmlFor="password" style={{ fontWeight: "500" }}>Password</label>
            <Password
              id="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              feedback={false}
              toggleMask
              showIcon={PrimeIcons.EYE_SLASH}
              hideIcon={PrimeIcons.EYE}
              inputClassName="p-primary-input"
              inputStyle={{ width: "100%", fontSize: "1rem", padding: "0.65rem 0.75rem", boxSizing: "border-box" }}
              pt={{
                root: { style: { width: "100%", display: "block" } },
                inputWrapper: { style: { width: "100%", display: "block" } },
              }}
            />
            {formik.touched?.password && formik.errors?.password && (
              <div className="p-error">{formik.errors?.password}</div>
            )}
          </div>

          {/* Login Button */}
          <Button
            type="submit"
            label={loading ? "..." : "Login"}
            className="p-black-btn"
            style={{ width: "100%", marginTop: "0.5rem", padding: "0.75rem" }}
          />

        </form>
      </div>
    </div>
  );
}
